import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "@/components/Layout";
import { useApp } from "@/context/AppContext";
import API from "@/lib/api";
import { geocode } from "@/lib/geo";
import { ArrowLeft, Search, Info } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function SuggestBusiness() {
  const navigate = useNavigate();
  const { categories, catName } = useApp();
  const [f, setF] = useState({ trade_name: "", category: "", phone: "", website: "", hours: "" });
  const [cityQuery, setCityQuery] = useState("");
  const [results, setResults] = useState([]);
  const [loc, setLoc] = useState(null);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async () => {
    if (!f.trade_name || !f.category) return toast.error("Nome e categoria obbligatori");
    let location = loc || {};
    if (!location.lat && cityQuery) { const r = await geocode(cityQuery); if (r[0]) location = { city: r[0].city, lat: r[0].lat, lng: r[0].lng }; }
    try {
      const res = await API.post("/businesses/suggest", {
        trade_name: f.trade_name, category: f.category, subcats: ["altro"],
        city: location.city || cityQuery, location,
        public_contacts: { phone: f.phone, website: f.website, email: "" }, hours: f.hours,
      });
      toast.success("Attività aggiunta come scheda non rivendicata");
      navigate(`/business/${res.data.id}`);
    } catch (e) { toast.error(e.response?.data?.detail || "Errore"); }
  };

  return (
    <Layout>
      <button onClick={() => navigate(-1)} className="inline-flex items-center gap-1 text-[#4A4E68] mb-3 text-sm"><ArrowLeft size={16} /> Indietro</button>
      <h1 className="font-serif text-2xl font-bold text-[#0F1230] mb-1">{"Aggiungi un'attività"}</h1>
      <p className="text-sm text-[#4A4E68] mb-4">{"Solo dati pubblici di attività con partita IVA. Verrà creata una scheda non rivendicata."}</p>

      <div className="bg-white rounded-[18px] border border-[#DADFEA] p-5 space-y-4">
        <div className="flex gap-2 bg-[#EEF0FB] border border-[#C3D6EF] rounded-xl p-3 text-xs text-[#1D4ED8]"><Info size={14} className="shrink-0 mt-0.5" /> {"Mai schede di persone private. Il titolare potrà rivendicarla verificando la partita IVA."}</div>
        <div><Label>Nome commerciale</Label><Input data-testid="suggest-name" value={f.trade_name} onChange={set("trade_name")} className="mt-1" /></div>
        <div>
          <Label>Categoria</Label>
          <div className="flex flex-wrap gap-2 mt-1">
            {categories.filter((c) => c.slug !== "varie").map((c) => (
              <button key={c.slug} data-testid={`suggest-cat-${c.slug}`} onClick={() => setF({ ...f, category: c.slug })} className={`px-3 h-9 rounded-full text-sm border ${f.category === c.slug ? "bg-[#1F4FE0] text-white border-[#1F4FE0]" : "border-[#DADFEA]"}`}>{catName(c)}</button>
            ))}
          </div>
        </div>
        <div>
          <Label>Città / indirizzo sede</Label>
          <div className="flex gap-2 mt-1">
            <Input data-testid="suggest-city" value={cityQuery} onChange={(e) => setCityQuery(e.target.value)} />
            <Button type="button" onClick={async () => setResults(await geocode(cityQuery))} variant="outline" className="rounded-full shrink-0"><Search size={16} /></Button>
          </div>
          {results.length > 0 && (
            <div className="mt-2 border border-[#DADFEA] rounded-xl overflow-hidden">
              {results.map((r, i) => (
                <button key={i} onClick={() => { setLoc({ city: r.city, lat: r.lat, lng: r.lng }); setCityQuery(r.city); setResults([]); }} className="block w-full text-left px-3 py-2 text-sm hover:bg-[#EEF1F7] border-b border-[#DADFEA] last:border-0">{r.label}</button>
              ))}
            </div>
          )}
        </div>
        <div><Label>Telefono aziendale</Label><Input value={f.phone} onChange={set("phone")} className="mt-1" /></div>
        <div><Label>Sito web</Label><Input value={f.website} onChange={set("website")} placeholder="https://" className="mt-1" /></div>
        <div><Label>Orari</Label><Input value={f.hours} onChange={set("hours")} className="mt-1" /></div>
        <Button data-testid="suggest-submit" onClick={submit} className="w-full h-12 bg-[#1F4FE0] text-white rounded-full">Aggiungi scheda</Button>
      </div>
    </Layout>
  );
}
